import React, { useState } from "react";
import { Link } from "react-router-dom";
import { postAuth } from "../auth/postAuth";
import "./LoginPage.css";
import logo from "../Assets/logo.png";
import Sidebar from "./sidebar";
import Footer from "./Footer";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    setSuccess("");

    try {
      const data = await postAuth("/auth/forgot.php", { email: email.trim() });
      setSuccess(
        data?.message ||
          "If an account exists for that email, a reset link has been sent."
      );
    } catch (err) {
      setError(err.message || "Unable to send a reset link. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className="tm-login-shell tm-login-shell--desktop-offset">
        <Sidebar />
        <div className="tm-login-brand">
          <div className="tm-logo">
            <img src={logo} alt="Custom Logo" />
            <div className="header-info">
              <p className="company-name">Table Mate</p>
              <p className="site-title">Back End Server Application</p>
            </div>
          </div>
          <div className="tm-login-brand-copy">
            <div className="tm-login-brand-heading">Data Centre Login</div>
            <p className="tm-login-brand-body">
              Secure access to your sales, tables, ratings, and menu analytics.
            </p>
          </div>
        </div>

        <div className="tm-login-main">
          <div className="tm-login-card">
            <h1 className="tm-login-title">Forgot password</h1>
            <p className="tm-login-subtitle">
              Enter the email for your Data Centre account. If it matches an
              account, we will send a reset link.
            </p>

            {error && <div className="tm-login-error">{error}</div>}
            {success && <div className="tm-login-success">{success}</div>}

            <form onSubmit={handleSubmit} className="tm-login-form">
              <div className="tm-login-field">
                <label htmlFor="email" className="tm-login-label">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  className="tm-login-input"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  disabled={!!success}
                />
              </div>

              <button
                type="submit"
                className="tm-login-button"
                disabled={submitting || !!success}
              >
                {submitting ? "Sending..." : "Send reset link"}
              </button>

              <Link to="/login" className="tm-login-forgot">
                Back to sign in
              </Link>
            </form>
          </div>

          <div className="tm-login-footer">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}
